import { render, staticRenderFns } from "./QuestionStartContains.vue?vue&type=template&id=70137fbf&scoped=true&"
import script from "./QuestionStartContains.vue?vue&type=script&lang=js&"
export * from "./QuestionStartContains.vue?vue&type=script&lang=js&"
import style0 from "./QuestionStartContains.vue?vue&type=style&index=0&id=70137fbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70137fbf",
  null
  
)

export default component.exports